<script>
import TileWMS from 'ol/source/TileWMS'

export default {
  name: 'ol-source-tile',

  inject: ['getLayer'],

  props: {
    url: {
      type: String,
      required: true
    },

    params: {
      type: Object,
      required: true
    }
  },

  watch: {
    params (newVal) {
      const params = this.tilewms.getParams()
      this.tilewms.updateParams({ ...params, ...newVal })
    }
  },

  data () {
    return {
      tilewms: null
    }
  },

  created () {
    this.tilewms = new TileWMS({
      // url: `https://gw.datall.cn/productapi/jh-api${this.url}`,
      // params: {
      //   FORMAT: 'image/png',
      //   VERSION: '1.1.0',
      //   ServiceKey: '4d853215facb39e18eb4453fae3abf84',
      //   UserName: 15071150840
      // }
    })

    this.getLayer(layer => {
      layer.setSource(this.tilewms)
    })
  },

  beforeDestroy () {
    this.tilewms = null
  },

  render () {
    return null
  }
}
</script>
